import React from 'react';
import { Container } from "react-bootstrap";
import ProjectService, { ProjectViewModel } from '../../../services/ProjectService';
import ProjectComponent from '../../../components/Configuration/Project/ProjectComponent';

function ProjectDetails() {

    const projectService = new ProjectService();
    const [data, setData] = React.useState<ProjectViewModel>();

    React.useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const result = await projectService.GetProjectDetails();
        setData(result);        
    };
    
    return (
        <Container style={{ padding: '20px' }}>
            <div >
                {data && <ProjectComponent projectDetails={data} />}
            </div>
        </Container>
    );
};

export default ProjectDetails;